import SelectBusiness from './SelectBusiness';
import SelectLocations from './SelectLocations';

export default { SelectBusiness, SelectLocations };
